var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"text--bold",style:(_vm.applyMinimalWidth ? 'min-width: 230px' : ''),attrs:{"color":_vm.chipColor,"label":""}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.chipIcon))]),_vm._v(" "+_vm._s(_vm.$t('planItems.state.' + _vm.innerValue))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }